var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksViewTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tasks_view_task"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 299.82,
    cy: 300,
    r: 299.73,
    transform: "translate(-124.32 299.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M500.67,301.61S411.92,426.43,302.44,426.43,104.22,298.05,104.22,298.05,193,169.67,302.44,169.67,500.67,301.61,500.67,301.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.67,
    cy: 298.89,
    r: 75.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 300.67,
    cy: 298.89,
    r: 42.22
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksViewTask);
export default __webpack_public_path__ + "static/media/tasks_view_task.82840a82c45fd78e8acd16f317550cb7.svg";
export { ForwardRef as ReactComponent };